import { relations } from 'drizzle-orm'
import { date, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
} from '../common/utils'
import { employees } from './employee'

export const salaryTypeEnum = pgEnum('salary_type', ['monthly', 'hourly'])

export const employeeSalaries = pgTable(
  'employee_salaries',
  {
    ...getBaseFields(),
    employeeId: getIdReference(() => employees.id),
    salaryType: salaryTypeEnum().notNull(),
    monthlySalary: getMonetaryField(), // Used when salaryType = 'monthly'
    hourlySalary: getMonetaryField(), // Used when salaryType = 'hourly'
    validFrom: date().notNull(),
    validTo: date(), // Null = current/ongoing salary
    notes: text(),
  },
  (table) => getBaseIndexes('employee_salaries', table),
)

export const employeeSalariesRelations = relations(
  employeeSalaries,
  ({ one }) => ({
    employee: one(employees, {
      fields: [employeeSalaries.employeeId],
      references: [employees.id],
    }),
  }),
)
